
import { trigger, state, transition, style, animate, animation, stagger } from '@angular/animations';

export let fadeInAnimation = animation([
    style({ opacity: 0 }),
    animate('{{ duration }} {{ easing }}')
], {
    params: {
        duration: '0.5s',
        easing: 'ease-out'
    }
});



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/animations.ts